// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faFacebook, faLinkedin, faTwitter, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons';
import jump from 'jump.js';
import Flickity from 'flickity';
import Carousel from './components/carousel.js';
import Accordion from 'accordion-js';

require('./layouts/popover-menu.js');
require('./components/hero.js');
require('./components/carousel.js');
require('./forms/form.js');
require('./components/video.js');
require('./components/ajax-load-posts.js');
require('./components/ajax-load-insights.js');
require('./components/map.js');
require('./components/popup.js');
require('./components/compliments-complaints.js');
require('./components/home-section-animations.js');

/**
 * Add Font Awesome
 */
library.add(faFacebook, faTwitter, faLinkedin, faYoutube, faInstagram);
dom.watch();

/**
 * Scroll to anchors
 */
if(typeof document.querySelectorAll('.accordion-container') && document.querySelectorAll('.accordion-container') !== null) {
  document.querySelectorAll('.accordion-container').forEach(function(item) {
    new Accordion(item);
  });
}

let links = document.querySelectorAll('.has-hash');

if(typeof links !=="undefined" && links !==null) {
  links.forEach((link) => {
    if (link.hash) {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        jump(link.hash, {
          duration: 500,
          offset: 0,
          callback: undefined,
          a11y: false
        })
      });
    }
  })
}


const mobileNav = document.querySelector('.js-mobile-opt-nav');

if( mobileNav !== null && typeof mobileNav !=="undefined" ) {
  mobileNav.addEventListener('change', (e) => {
    window.location = e.target.value;
  });
}

jQuery(document).ready(function ($) {
  $(".featured-article").addClass("featured-article--ready");
}(jQuery));
